import React from 'react';

class TripleSwitch extends React.Component {

    handleChange( value ) {

        this.props.onChange( { target: { name: this.props.name, value } } );

    }

    render() {

        const classNames = [ 'triple-switch', 'triple-switch-' + this.props.value ];

        if ( this.props.disabled ) {

            classNames.push( 'triple-switch-disabled' );

        }

        return (

            <div className={classNames.join( ' ' )}>

                <div className="triple-switch-toggle">

                    <div className="triple-switch-handle"></div>

                    <div className="triple-switch-touch triple-switch-touch-false" onClick={e => this.handleChange( false )}></div>
                    <div className="triple-switch-touch triple-switch-touch-null"  onClick={e => this.handleChange( null  )}></div>
                    <div className="triple-switch-touch triple-switch-touch-true"  onClick={e => this.handleChange( true  )}></div>

                </div>

            </div>

        );

    }

}

export default TripleSwitch;